import { useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Switch from '@mui/material/Switch';
import styles from '../../../../styles/case/Case.module.scss';
import { Button } from '@mui/material';


export default function HighlightNodes(props) {
    const [isFocused, setIsFocused] = useState(false);
    const [crtResult, setCrtResult] = useState(-1);
    const refText = useRef(null);
    const refInInfo = useRef(null);
    const crtFocusedNode = useRef(null);

    const searchedString = props.searchedString;
    const setSearchedString = props.setSearchedString;
    const setFocusedNodes = props.setFocusedNodes;
    const results = props.results;

    const numResults = results?.length || 0;

    function setFocusedNode(node) {
        if (node === crtFocusedNode.current) return;
        if (node && crtFocusedNode.current && node.type === crtFocusedNode.current.type && node.value === crtFocusedNode.current.value) return;
        crtFocusedNode.current = node;
        if (node)
            setFocusedNodes([node]);
        else
            setFocusedNodes([]);
    }

    useEffect(() => { // handle global keyboard shortcut
        const handleKeyDown = (evt) => {
            if (evt.key === 'F3') {
                evt.preventDefault();
                setIsFocused(true);
            }
            if (evt.key === 'f' && evt.ctrlKey) {
                evt.preventDefault();
                setIsFocused(true);
            }
            if (isFocused && evt.key === 'Escape') {
                evt.preventDefault();
                setIsFocused(false);
            } else {
                //console.log(evt);
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isFocused]);

    useEffect(() => {
        if (isFocused) {
            refText.current.focus();
        } else {
            refText.current.value = '';
            setSearchedString('');
        }
    }, [isFocused, setSearchedString]);

    useEffect(() => {
        if (numResults > 0) {
            setCrtResult(0);
            setFocusedNode(results[0]);
        } else {
            setCrtResult(-1);
            setFocusedNode(null);
        }
        //setFocusedNodes will actually change on every parent render, but it's ok cuz it just uses a state setter and a ref.current
        //eslint-disable-next-line
    }, [results, numResults]);

    function onKeyUp(evt) {
        if (evt.key === 'Enter') {
            if (evt.shiftKey) { goPrevResult(); } else { goNextResult(); }
        } else if (evt.key === 'Escape') {
            setIsFocused(false);
        }
    }

    function goNextResult() {
        if (crtResult === -1) { setFocusedNode(null); return; }
        const nextResult = (crtResult + 1) % numResults;
        setCrtResult(nextResult);
        setFocusedNode(results[nextResult]);
    }

    function goPrevResult() {
        if (crtResult === -1) { setFocusedNode(null); return; }
        const prevResult = (crtResult + numResults - 1) % numResults;
        setCrtResult(prevResult);
        setFocusedNode(results[prevResult]);
    }

    return (
        <div className={styles.highlightComponent}>
        <div className={styles.searchButtonWrapper} style={{display: (isFocused ? 'none' : 'flex')}} title="Search nodes" onClick={() => setIsFocused(true)} >
            <div className={styles.searchButton} />
        </div>
        <div style={{display: (isFocused ? 'block' : 'none')}}>
            <button className={styles.closeButton} onClick={() => setIsFocused(false)}>X</button>
        </div>
        <div style={{display: (isFocused ? 'block' : 'none')}}>
            <fieldset>
                <legend>Search nodes</legend>
                <div>
                    <TextField
                        inputRef={refText}
                        autoComplete='off'
                        className={styles.highlightText}
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                        placeholder="Search..."
                        value={searchedString}
                        onKeyUp={onKeyUp}
                        onChange={(evt) => setSearchedString(evt.target?.value || '')}
                    />
                </div>
                <div style={{padding: '4px 10px' }} >
                <FormControlLabel className={styles.highlightInInfo} control={
                    <Switch 
                        inputRef={refInInfo}
                        checked={props.searchInInfo} size="small"
                        inputProps={{ 'aria-label': 'controlled' }}
                        onChange={(evt) => {props.setSearchInInfo(evt.target.checked)}}
                    />
                } label="Search in info" />
                </div>
                <div className={styles.resultsLabel}>
                    {numResults === 0 ? 'No matches' : 'Results: ' + (crtResult + 1) + ' of ' + numResults}
                </div>
                <div style={{padding: '4px 10px' }} >
                    <button onClick={goNextResult}>Next</button>
                    <button onClick={goPrevResult}>Previous</button>
                </div>
            </fieldset>
        </div>
        </div>
    )
}